//import { required, requiredIf } from "vuelidate/lib/validators";
import { updateForm } from "@state/modules";

export const state = {
  form: {}
};

export const validations = {
  form: {}
};

export const getters = {};

export const mutations = {
  updateForm
};

export const actions = {};
